import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { faArrowLeft, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const Error404 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleClearStorage = () => {
    localStorage.clear();
    sessionStorage.clear();

    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
    navigate('/login');
  };

  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">404</div>
        <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
          The page you're looking for is not found.
        </p>
        <hr />
        <p>
          Make sure the address is correct and that the page hasn't moved. If
          you think this is a mistake,
          <a href="mailto:sultantippu@traya.health" className="ms-1">
            contact us
          </a>
          .
        </p>
        <div className="mt-3">
          <button className="btn btn-secondary btn-sm me-2" onClick={handleGoBack}>
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
            Go Back
          </button>
          <button className="btn btn-primary btn-sm me-2" onClick={handleClearStorage}>
            <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
            Clear Cache and Go to Login
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Error404;